












import {
  defineComponent
} from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'FooterLogos',
  data() {
    return {
      logos: [
        {
          file: 'mastercard.svg',
          alt: 'Mastercard'
        },
        {
          file: 'vipps.svg',
          alt: 'Vips'
        },
        {
          file: 'posten-bring.svg',
          alt: 'Posten Bring'
        },
        {
          file: 'visa.svg',
          alt: 'Visa'
        },
        {
          file: 'agrideler-faktura.svg',
          alt: 'Agrideler Faktura'
        },
        {
          file: 'svea.svg',
          alt: 'SVEA'
        }
      ]
    };
  }
});

